import axiosInstance from '../api/axios';
import { IMaterial } from '../models/disciplines';
import {
  IViewStatusResponse,
  MaterialViewType,
  ViewOrigin,
} from '../models/contentView';

/** Rota `/:slug/opened` por subtipo de material. */
const MATERIAL_VIEW_PATH: Record<MaterialViewType, string> = {
  workbook: 'workbooks',
  mindmap: 'mindmaps',
  podcast: 'podcasts',
};

/**
 * Marca/desmarca um material como visto (toggle: cada chamada inverte o status).
 * Roteia para `/workbooks|mindmaps|podcasts/:slug/opened` conforme o subtipo.
 * Use `viewStatus.viewed` da resposta como fonte da verdade para a UI.
 */
export async function markMaterialView(
  slug: string,
  type: MaterialViewType = 'workbook',
  origin?: ViewOrigin
): Promise<IViewStatusResponse> {
  const response = await axiosInstance.post(
    `/${MATERIAL_VIEW_PATH[type]}/${slug}/opened`,
    origin ? { origin } : undefined
  );

  return response.data;
}

export async function getMaterialBySlug(slug: string): Promise<IMaterial> {
  const response = await axiosInstance.get(`/materials/new/${slug}`);

  return response.data;
}
